import { render } from "./link-button.vue?vue&type=template&id=bbab6e5a"
import script from "./link-button.vue?vue&type=script&lang=js"
export * from "./link-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__